import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { LayoutComponent } from 'app/layout/layout.component';
import { ClassicLayoutModule } from './layouts/classic/classic.module';
import { EmptyLayoutModule } from './layouts/empty/empty.module';

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    ClassicLayoutModule,
    EmptyLayoutModule,
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    FuseDrawerModule,
    RouterModule,
    FuseLoadingBarModule,
  ],
  exports: [LayoutComponent],
})
export class LayoutModule {}
